"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const employees = [{
  name: "Elena Vance",
  position: "Wellness Expert",
  bio: "Elena is a certified holistic health coach specializing in the intersection of physical intimacy and emotional well-being. With a background in psychology, she provides our readers with evidence-based guides on maintaining healthy, vibrant relationships through mindful connection.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654438/img/expert_elena_vance.png"
}, {
  name: "Marcus Thorne",
  position: "Relationship Strategist",
  bio: "Marcus brings a decade of experience in interpersonal communication and modern dating dynamics. His 'Playbook' series has helped thousands navigate the complexities of love in the digital age, focusing on authenticity and clear communication.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654438/img/expert_marcus_thorne.png"
}, {
  name: "Dr. Sarah Chen",
  position: "Clinical Consultant",
  bio: "Dr. Chen is a licensed therapist who contributes deep clinical insights into our wellness and love sections. Her work focuses on breaking down taboos and providing professional perspectives on intimacy, self-love, and psychological health.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654438/img/expert_sarah_chen.png"
}, {
  name: "Julian Rossi",
  position: "Lifestyle Editor",
  bio: "Julian curates 'The Arsenal' and our lifestyle guides, ensuring every recommendation meets our high standards for quality and elegance. He bridges the gap between luxury living and practical wellness advice for the modern reader.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654438/img/expert_julian_rossi.png"
}];
export default function StrategicLeads() {
  return <section data-section-id="222637" id="meet-the-experts" className="bg-background text-foreground py-20 md:py-32">
      <div className="container mx-auto px-6 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-6xl font-bold tracking-tight text-foreground font-default mb-6">
            Meet the Experts
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default leading-relaxed">
            The editorial voices behind our guides, news, and wellness insights.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16 justify-center max-w-6xl mx-auto">
          {employees.map((employee, i) => <div data-index={i} key={i} className="group flex flex-col items-center text-center">
              <div className="relative w-full aspect-[3/4] mb-6 overflow-hidden rounded-xl bg-neutral-100 shadow-xl shadow-foreground/5">
                <img src={employee.image} alt={`Portrait of ${employee.name}`} className="absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-in-out grayscale group-hover:grayscale-0 group-hover:scale-105" />
              </div>
              
              <h3 className="text-xl font-bold text-foreground font-default mb-1">
                {employee.name}
              </h3>
              <p className="text-sm font-medium uppercase tracking-wider text-primary mb-5">
                {employee.position}
              </p>

              <Dialog>
                <DialogTrigger asChild>
                  <Button variant="outline" size="icon" className="rounded-full size-10 border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-400 hover:scale-110">
                    <Plus className="size-4" />
                    <span className="sr-only">View {employee.name}'s bio</span>
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-md rounded-2xl border-border bg-background">
                  <DialogHeader>
                    <DialogTitle className="text-2xl font-bold font-default text-foreground">
                      {employee.name}
                    </DialogTitle>
                    <DialogDescription className="text-base font-medium text-primary">
                      {employee.position}
                    </DialogDescription>
                  </DialogHeader>
                  <div className="py-6">
                    <p className="text-foreground font-default leading-relaxed">
                      {employee.bio}
                    </p>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
      </div>
    </section>;
}